import 'twin.macro';
import 'styled-components/macro';

import { TextButton } from 'component-lib/atoms/button/Button';

export interface MenuItemProps {
  disabled?: boolean;
  active?: boolean;
  onOpenSubmenu?: () => void;
  showIcon?: boolean;
  children?: React.ReactNode;
}

export const MenuItem = ({ children, onOpenSubmenu, showIcon, ...props }: MenuItemProps) => (
  <TextButton iconRight={showIcon ? 'arrow-small-right' : undefined} onClick={onOpenSubmenu} tw="flex px-0" {...props}>
    {children}
  </TextButton>
);
